import { render, staticRenderFns } from "./inventory-devices-link.vue?vue&type=template&id=12dc4f51&"
import script from "./inventory-devices-link.vue?vue&type=script&lang=js&"
export * from "./inventory-devices-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports